import { render } from "./AlertModal.vue?vue&type=template&id=2158d77d&scoped=true"
import script from "./AlertModal.vue?vue&type=script&lang=js"
export * from "./AlertModal.vue?vue&type=script&lang=js"

import "./AlertModal.vue?vue&type=style&index=0&id=2158d77d&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Infinitus.CM\\Admin\\lab22.iot.adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2158d77d"]])

export default __exports__